import type { CopilotMode, MacSuggestion } from '@/api/macSuggest';

export type { CopilotMode, MacSuggestion };

export interface CopilotRequest {
  intent: string;
  mode: CopilotMode | '';
  variants: number;
  useFullContext: boolean;
}

export type AIDraftKind = 'none' | 'ai_clean' | 'ai_edited';

export interface AIDraftState {
  kind: AIDraftKind;
  suggestionId: string;
  eventId: string;
  mode: string;
  originalText: string;
}

export const EMPTY_AI_DRAFT: AIDraftState = {
  kind: 'none',
  suggestionId: '',
  eventId: '',
  mode: '',
  originalText: '',
};

export const MODE_LABELS: Record<CopilotMode, string> = {
  informational: 'Информативно',
  empathetic: 'Эмпатично',
  scheduling: 'Запись / расписание',
  clinical: 'Клинически',
  followup: 'Follow-up',
};

export const ALL_MODES: CopilotMode[] = ['informational', 'empathetic', 'scheduling', 'clinical', 'followup'];
